import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import classes from './Field.module.css';
import { FieldKeyEditable, FieldKeyStatic } from './FieldKey';
import { FieldTypeSelector } from './FieldTypeSelector';
import { useSchemaBuilderContext } from '../../SchemaContext';
export function Field({ schema, name, onChange, onEnter, onEsc, onNameChange, deprecatedNames, className, level, }) {
    const { readOnly } = useSchemaBuilderContext();
    const handleTypeChange = onChange
        ? (type) => {
            const newValue = {
                default: undefined,
                type,
            };
            switch (type) {
                case 'object':
                    newValue.properties = {
                        ['']: {
                            type: 'string',
                        },
                    };
                    break;
                case 'array':
                    newValue.items = {
                        type: 'string',
                    };
                    break;
            }
            onChange(newValue);
        }
        : undefined;
    return (_jsxs("div", { className: clsx(classes.fieldWrapper, className), children: [level === 0 ? (_jsx("span", { className: 'text-gray-500', children: "schema:" })) : (_jsx(_Fragment, { children: onNameChange && !readOnly ? (_jsxs(_Fragment, { children: [_jsx(FieldKeyEditable, { autoFocus: !name, value: name, onChange: onNameChange, onEnter: onEnter, onEsc: onEsc, deprecatedNames: deprecatedNames }), _jsx("span", { children: ":" })] })) : (_jsxs(FieldKeyStatic, { children: [name, ":"] })) })), _jsx(FieldTypeSelector, { type: schema === null || schema === void 0 ? void 0 : schema.type, onTypeChange: handleTypeChange })] }));
}
//# sourceMappingURL=Field.js.map